import { useEffect } from "react";
import { useGlobalContext } from "../../Context/GlobalContext";

const PriceSummary = () => {
  const { items, setItemData, isMembershipApplied } = useGlobalContext();

  // Calculate totals
  useEffect(() => {
    if (!items || items.length === 0) return;
    const total = items.reduce((sum, item) => {
      const price = parseFloat(item?.price) || 0;
      const qty = parseInt(item.quantity) || 1;
      return sum + price * qty;
    }, 0);
    setItemData((prev) => ({
      ...(prev || {}),
      company: 1,
      panel: "outlet",
      newsletter: 1,
      currency: "SGD",
      payment_type: "payatstore",
      payment_status: 1,
      sub_total: total.toFixed(2),
      grand_total: total.toFixed(2),
      gst_rate: 9,
    }));
  }, [items, isMembershipApplied, setItemData]);

  // Sync items JSON into itemData (preserve membership during network fluctuations)
  useEffect(() => {
    setItemData((prev) => ({
      ...(prev || {}),
      company: 1,
      panel: "outlet",
      newsletter: 1,
      currency: "SGD",
      payment_type: "payatstore",
      payment_status: 1,
      membership: prev?.membership ?? (isMembershipApplied ? 1 : 0),
      items: JSON.stringify(items),
    }));
  }, [items, isMembershipApplied, setItemData]);
  return null; // ✅ Important: must return something in React components
};

export default PriceSummary;
